import { selectors as browserMetaSelectors } from 'wanderu-ducks-browser-meta';
import Logger from 'wanderu-logger';
import wapiService from 'wanderu-service-wapi';

import { gtm } from '../gtm';
import { SnowplowService } from '../snowplow';

const logger = Logger.getLogger('UserEvents');
let _store;

function initUserEvents(store) {
    _store = store;
}

async function getMetaData() {
    let userLocation;
    if (_store) {
        userLocation = browserMetaSelectors.selectUserLocation(_store.getState());
    } else {
        logger.warn('UserEvents not inited with redux store');
    }

    const {
        domainUserId,
        networkUserId,
    } = await SnowplowService.getIds();

    return {
        userLocation,
        domainUserId,
        networkUserId,
    };
}

async function identifyUser(userInfo) {
    const {
        source,
        identityId,
        email,
        firstName,
        lastName,
        currency,
        locale,
    } = userInfo;

    if (email) {
        gtm.dataLayer.push({
            user_data: {
                email,
                address: {
                    first_name: firstName,
                    last_name: lastName,
                },
            },
        });
    }

    // TODO this needs to be unset when user logs out
    if (identityId) {
        gtm.dataLayer.push({ user_id: identityId });
    }

    try {
        const {
            userLocation,
            domainUserId,
            networkUserId,
        } = await getMetaData();

        return await wapiService.post('events.json', {
            body: {
                event: 'user:action:identify',
                data: {
                    cognito_identity_id: identityId,
                    sp_domain_id: domainUserId,
                    sp_network_id: networkUserId,
                    email: email,
                    location: userLocation,
                    source,
                    first_name: firstName,
                    last_name: lastName,
                    user_locale: locale,
                    user_currency: currency,
                },
                event_timestamp: Date.now(),
            },
        });
    } catch (ex) {
        logger.error('identifyUser', ex);
        return null;
    }
}

async function trackEmailSignup({
    email,
    signupSource,
    locale,
    extra = {},
}) {
    if (email) {
        gtm.dataLayer.push({
            user_data: { email },
        });
    }

    try {
        const {
            domainUserId,
            networkUserId,
        } = await SnowplowService.getIds();

        return await wapiService.post('events.json', {
            body: {
                event: 'user:action:email',
                data: {
                    email,
                    source: 'ui-react',
                    signup_source: signupSource,
                    sp_domain_id: domainUserId,
                    sp_network_id: networkUserId,
                    user_locale: locale,
                    ...extra,
                },
                event_timestamp: Date.now(),
            },
        });
    } catch (ex) {
        logger.error('trackEmailSignup', ex);
        return null;
    }
}

async function fireCheckoutEvent(info) {
    const {
        linkType,
        identityId,
        email,
        itineraryId,
        locale,
        currency,
    } = info;

    try {
        const {
            userLocation,
            domainUserId,
            networkUserId,
        } = await getMetaData();

        return wapiService.post('events.json', {
            body: {
                event: 'user:action:checkout',
                data: {
                    cognito_identity_id: identityId,
                    sp_domain_id: domainUserId,
                    sp_network_id: networkUserId,
                    email: email,
                    location: userLocation,
                    user_locale: locale,
                    user_currency: currency,
                    link_type: linkType,
                    itinerary_id: itineraryId,
                },
                event_timestamp: Date.now(),
            },
        });
    } catch (ex) {
        logger.error('fireCheckoutEvent', ex);
        return null;
    }
}

export {
    fireCheckoutEvent,
    identifyUser,
    initUserEvents,
    trackEmailSignup,
};
